import connector from './connector';

const TitleHandler = ({ totalUnRead }) => {
  document.title = totalUnRead ? `(${totalUnRead}) Ommnio` : 'Ommnio';
  // Renderless component
  return null;
};

export default connector(TitleHandler);
